import { Notification as NotificationType } from './NotificationsProvider/utils';

export const filterUnreadNotifications = (notifications: NotificationType[]) =>
  notifications.filter((notification) => !notification.isRead);
